module.exports = __webpack_public_path__ + "img/store_marker.1379c51.png";